export default {
  // Page titles
  'pages.device.register.title': 'Device Terminal',
  'pages.device.register.subtitle':
    'Manage POS device authorization, binding and BIR tax compliance info',

  // Statistics
  'pages.device.register.stat.total': 'Total Devices',
  'pages.device.register.stat.online': 'Online Devices',
  'pages.device.register.stat.offline': 'Offline Devices',
  'pages.device.register.stat.compliant': 'Compliant Devices',
  'pages.device.register.stat.onlineRate': 'Online Rate',

  // Buttons
  'pages.device.register.export': 'Export',
  'pages.device.register.registerDevice': 'Register Device',
  'pages.device.register.copy': 'Copy',
  'pages.device.register.edit': 'Edit',
  'pages.device.register.save': 'Save',
  'pages.device.register.cancel': 'Cancel',
  'pages.device.register.confirm': 'Confirm',
  'pages.device.register.back': 'Back',

  // Messages
  'pages.device.register.message.exportDeveloping':
    'Export feature is under development...',
  'pages.device.register.exportFileName': 'Device List',
  'pages.device.register.message.exportSuccess': 'Exported successfully',
  'pages.device.register.message.exportFailed': 'Export failed',
  'pages.device.register.message.wrongPassword': 'Incorrect password',
  'pages.device.register.message.deleteSuccess': 'Deleted successfully',
  'pages.device.register.message.deleteFailed': 'Delete failed',
  'pages.device.register.message.registerSuccess': 'Registered successfully',
  'pages.device.register.message.copySuccess': 'Copied successfully',
  'pages.device.register.message.editSuccess': 'Updated successfully',
  'pages.device.register.message.editFailed': 'Update failed',
  'pages.device.register.message.fetchStoreFailed':
    'Failed to fetch store list',

  // Delete modal
  'pages.device.register.deleteConfirm': 'Delete Confirmation',
  'pages.device.register.deleteConfirmText':
    'Please enter password to confirm deletion:',
  'pages.device.register.deletePasswordPlaceholder': 'Enter password',

  // Search
  'pages.device.register.search.placeholder':
    'Search device name, serial number (SN)',

  // Common labels
  'pages.device.register.deviceId': 'Device ID',
  'pages.device.register.deviceName': 'Device Name',
  'pages.device.register.deviceType': 'Device Type',
  'pages.device.register.store': 'Store',
  'pages.device.register.tenant': 'Tenant',
  'pages.device.register.snCode': 'Serial Number',
  'pages.device.register.activationStatus': 'Activation Status',
  'pages.device.register.activationCode': 'Activation Code',
  'pages.device.register.onlineStatus': 'Online Status',
  'pages.device.register.onlineStatus.online': 'Online',
  'pages.device.register.onlineStatus.offline': 'Offline',
  'pages.device.register.expireDate': 'Expiry Date',
  'pages.device.register.terminalNo': 'Terminal No.',

  // Table columns (unique)
  'pages.device.register.column.deviceCode': 'Hardware Code',
  'pages.device.register.column.os': 'OS',
  'pages.device.register.column.expiryDays': 'Expiry Days',
  'pages.device.register.column.action': 'Action',
  'pages.device.register.column.bappBound': 'B-App Bound',
  'pages.device.register.column.version': 'Version',
  'pages.device.register.tag.bound': 'Bound {date}',
  'pages.device.register.tag.unbound': 'Unbound',

  // Unbind BAPP
  'pages.device.register.message.unbindBappSuccess':
    'B-App unbound successfully',
  'pages.device.register.message.unbindBappFailed': 'Failed to unbind B-App',
  'pages.device.register.unbindBapp.title': 'Unbind B-App',
  'pages.device.register.unbindBapp.confirm': 'Confirm Unbind',
  'pages.device.register.unbindBapp.cancel': 'Cancel',
  'pages.device.register.unbindBapp.warning':
    'Device {name} is bound to B-App (SN: {sn}). After unbinding, this B-App will no longer work. Continue?',

  // Dividers
  'pages.device.register.divider.basicInfo': 'Basic Information',
  'pages.device.register.divider.otherInfo': 'Other Information',

  // Form - common
  'pages.device.register.form.input': 'Please enter',
  'pages.device.register.form.select': 'Please select',
  'pages.device.register.form.selectDate': 'Please select',

  // Form - validation & placeholders
  'pages.device.register.form.tenantPlaceholder': 'Select tenant',
  'pages.device.register.form.tenantRequired': 'Please select a tenant',
  'pages.device.register.form.storePlaceholder': 'Select store',
  'pages.device.register.form.storePlaceholderDisabled': 'Select tenant first',
  'pages.device.register.form.storeRequired': 'Please select a store',
  'pages.device.register.form.deviceNameRequired': 'Please enter device name',
  'pages.device.register.form.deviceNamePlaceholder': 'e.g. Front POS 01',
  'pages.device.register.form.deviceTypeRequired': 'Please select device type',
  'pages.device.register.form.expireDatePlaceholder': 'Select expiry date',
  'pages.device.register.form.expireDatePlaceholderEdit':
    'Select authorization end date',
  'pages.device.register.form.expireDateRequired': 'Please select expiry date',
  'pages.device.register.form.expireDateValidator':
    'Expiry date cannot be earlier than today',
  'pages.device.register.form.expireDateTooltip':
    'Defaults to tenant subscription expiry date',
  'pages.device.register.form.terminalNoRequired':
    'Please enter terminal number',

  // Form - other info labels
  'pages.device.register.minNo': 'MIN Number',
  'pages.device.register.ptuNo': 'PTU Number',
  'pages.device.register.issueDate': 'Issue Date',
  'pages.device.register.accNo': 'Accreditation No.',
  'pages.device.register.softwareName': 'Software Name',

  // Detail modal
  'pages.device.register.detail.title': 'Device Details',
  'pages.device.register.detail.basicInfo': 'Basic Information',
  'pages.device.register.detail.ptuInfo': 'PTU Information',

  // Edit modal
  'pages.device.register.editTitle': 'Edit Device',

  // Add modal
  'pages.device.register.addTitle': 'Register Device',
};
